import { Component, input } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-error-component',
  imports: [MatCardModule, MatIconModule],
  templateUrl: './error-component.component.html',
  styleUrl: './error-component.component.scss',
})
export class ErrorComponentComponent {
  errorMessage = input<string | undefined>('');
}
